import React from 'react';
import { Text, View } from 'react-native';
import { create } from '../display-names';

const ItemPrimitive = _ref => {
  let {
    children,
    style
  } = _ref;
  return /*#__PURE__*/React.createElement(View, {
    style: style
  }, children);
};

const ItemTitle = create(_ref2 => {
  let {
    children,
    style
  } = _ref2;
  return /*#__PURE__*/React.createElement(Text, {
    style: style,
    selectable: false
  }, children);
}, 'ItemTitle');
const ItemSubtitle = create(_ref3 => {
  let {
    children,
    style
  } = _ref3;
  return /*#__PURE__*/React.createElement(Text, {
    style: style,
    selectable: false
  }, children);
}, 'ItemSubtitle');
export { ItemPrimitive, ItemSubtitle, ItemTitle };
//# sourceMappingURL=index.js.map